import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Header from "../../components/Header";
import { FormattedMessage } from "react-intl";
import NotaCertLookup from "../../components/Certificates/NotaCertLookup";

function LinkNotaCert({ history, match }) {
  const { idnotacert } = match.params;

  return (
    <>
      <Header>
        <h1>
          <FormattedMessage id="certificates.title" defaultMessage="Certificates" />
        </h1>
      </Header>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <NotaCertLookup history={history} id={idnotacert}></NotaCertLookup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default LinkNotaCert;
